import React, { forwardRef } from "react";
import { PeriodBlock } from "./PeriodBlock";

const LORA   = { fontFamily: "'Lora', Georgia, serif" };
const SERIF  = { fontFamily: "'Cormorant Garamond', Georgia, serif" };
const CAVEAT = { fontFamily: "'Caveat', cursive" };

const JOURS_FULL = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
const MOIS_FR    = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

function formatFullDate(dateStr) {
  try {
    const d = new Date(dateStr + "T00:00:00");
    return `${JOURS_FULL[d.getDay()]} ${d.getDate()} ${MOIS_FR[d.getMonth()]}`;
  } catch {
    return dateStr;
  }
}

export const DaySection = forwardRef(function DaySection({ jour, isToday }, ref) {
  const fullDate = formatFullDate(jour.date);

  return (
    <section
      ref={ref}
      className="mb-10"
      data-testid={`day-section-${jour.numero_jour}`}
    >
      {/* Sticky day header — sticks below navbar + day selector (~108px) */}
      <div
        className="sticky bg-[#F9F6F0] border-b border-[#DCD4C6] py-3 mb-4 z-10"
        style={{ top: "108px" }}
      >
        <div className="flex items-baseline gap-2 flex-wrap">
          <span className="text-2xl sm:text-3xl font-semibold text-[#2B2623]" style={SERIF}>
            Jour {jour.numero_jour}
          </span>
          <span className="text-sm text-[#9A8F86]" style={LORA}>
            — {fullDate}
          </span>
          {isToday && (
            <span
              className="text-xs bg-[#C17F59] text-[#F9F6F0] px-2 py-0.5 rounded-sm"
              style={LORA}
            >
              Aujourd'hui
            </span>
          )}
        </div>

        {jour.titre_jour && (
          <p
            className="text-xl text-[#8B5E34] mt-0.5"
            style={{ ...CAVEAT, fontStyle: "italic" }}
          >
            {jour.titre_jour}
          </p>
        )}

        {jour.heure_reveil && (
          <p className="text-xs text-[#C17F59] mt-1" style={LORA}>
            ⏰ Réveil recommandé : {jour.heure_reveil}
          </p>
        )}
      </div>

      {/* Conseil du jour */}
      {jour.conseil_jour && (
        <div className="flex items-start gap-2 border border-[#EDE8E0] px-4 py-3 rounded-sm mb-4 bg-[#FBF8F4]">
          <span className="text-base flex-shrink-0 select-none">💡</span>
          <p className="text-sm text-[#5C554E] italic" style={LORA}>
            {jour.conseil_jour}
          </p>
        </div>
      )}

      {/* Period blocks */}
      <div className="space-y-1">
        <PeriodBlock period="matin"      data={jour.matin} />
        <PeriodBlock period="apres_midi" data={jour.apres_midi} />
        <PeriodBlock period="soiree"     data={jour.soiree} />
      </div>
    </section>
  );
});
